import { UserButton } from '@clerk/clerk-react';
import { useStatsigClient } from '@statsig/react-bindings';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ProvidedAppContext, User } from '../App.interfaces';
import { useApp } from '../helpers/api-helpers';
import { ReactComponent as ExclamationMark } from '../icons/exclamation-mark.svg';
import { ReactComponent as BillingIcon } from '../icons/profile-billing.svg';
import { ReactComponent as EnrollmentsIcon } from '../icons/profile-enrollments.svg';
import { ReactComponent as InfoIcon } from '../icons/profile-info.svg';
import styles from './ProfileMenu.module.css';

export const NotificationIcon = () => (
  <span className={styles.notification}>
    <ExclamationMark />
  </span>
);

export const missingUserInfoQuestions = (user: User | undefined) => {
  const userInfo = user?.tfCompanyData;
  if (isEmpty(userInfo)) {
    return true;
  }

  return Object.values(userInfo).some((info) => isEmpty(info));
};

export function ProfileMenu({ className }: { className?: string }) {
  const history = useHistory();
  const { user } = useApp() as ProvidedAppContext;
  const [_open, setOpen] = useState<boolean>(false);
  const { client } = useStatsigClient();

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  // Close the menu if we navigate somewhere
  const location = useLocation();
  useEffect(() => {
    close();
  }, [location?.key, close]);

  const hasNotification = missingUserInfoQuestions(user);
  const newInfoPageGate = client.checkGate('new_info_page');

  return (
    <div className={cn(styles.wrapper, className, styles.clerkProfile)}>
      {newInfoPageGate && hasNotification && <NotificationIcon />}
      <UserButton>
        <UserButton.MenuItems>
          <UserButton.Action
            label={'Enrollments'}
            labelIcon={<EnrollmentsIcon />}
            onClick={() => {
              history.push('/profile/enrollments');
            }}
          />
          <UserButton.Action
            label={'Billing'}
            labelIcon={<BillingIcon />}
            onClick={() => {
              history.push('/profile/billing');
            }}
          />
          <UserButton.Action
            label={'Info'}
            labelIcon={
              <span className={styles.userInfoClerkButton}>
                {newInfoPageGate && hasNotification && <NotificationIcon />}
                <InfoIcon />
              </span>
            }
            onClick={() => {
              const infoLink =
                newInfoPageGate && hasNotification
                  ? '/profile/info/edit'
                  : '/profile/info';

              history.push(infoLink);
            }}
          />
        </UserButton.MenuItems>
      </UserButton>
    </div>
  );
}
